import { fromJS } from 'immutable'

import { apiInitialState, apiNamespaceReducer } from 'common/reducers/api'

const initialState = fromJS({
  ...apiInitialState('sso_authorization_url'),
  ...apiInitialState('sso_callback')
})

function ssoReducer(state = initialState, action) {
  const apiResult = apiNamespaceReducer(state, action, 'auth', initialState)
  if (apiResult) {
    return apiResult
  }

  return state
}

export default ssoReducer
